
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/reward-store",
      function () {
        return require("private-next-pages/reward-store/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/reward-store"])
      });
    }
  